<o2-sheet side="right" maxWidth="37.5rem">
  <div o2SheetHeader>
    <h2 o2SheetTitle>{{ sheetTitle() }}</h2>
  </div>

  <div o2SheetBody>
    <o2-accordion-group [resetOnParentOpen]="sheetRef().isOpen()">
      <!-- Info Profilo Accordion -->
      <o2-accordion-item label="Info profilo">
        <div class="p-5 pt-2">
          <form [formGroup]="tenantForm" class="flex flex-col gap-3.5">
            <!-- Nome -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="companyName" class="w-1/4 sheet-label pt-2"
                >Nome*</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="companyName"
                  type="text"
                  formControlName="companyName"
                  placeholder="Nome azienda"
                />
                <hlm-error
                  >Il nome è obbligatorio (minimo 2 caratteri)</hlm-error
                >
              </hlm-form-field>
            </div>

            <!-- Indirizzo (Via) -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="street" class="w-1/4 sheet-label pt-2"
                >Indirizzo</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="street"
                  type="text"
                  formControlName="street"
                  placeholder="Via, numero civico"
                />
              </hlm-form-field>
            </div>

            <!-- Città -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="city" class="w-1/4 sheet-label pt-2"
                >Città</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="city"
                  type="text"
                  formControlName="city"
                  placeholder="Città"
                />
              </hlm-form-field>
            </div>

            <!-- Provincia -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="province" class="w-1/4 sheet-label pt-2"
                >Provincia</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <input
                    hlmInput
                    id="province"
                    type="text"
                    formControlName="province"
                    placeholder="Es. RM"
                  />
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="provinceTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #provinceTooltip>
                  <div class="max-w-xs">
                    La provincia viene utilizzata come Foro Competente nei
                    contratti (Art. 9). Assicurati di inserirla correttamente.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- CAP -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="postalCode" class="w-1/4 sheet-label pt-2"
                >CAP</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="postalCode"
                  type="text"
                  formControlName="postalCode"
                  placeholder="CAP"
                />
              </hlm-form-field>
            </div>

            <!-- Email -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="email" class="w-1/4 sheet-label pt-2"
                >Email</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="email"
                  type="email"
                  formControlName="email"
                  placeholder="Email"
                />
                <hlm-error>Inserire un'email valida</hlm-error>
              </hlm-form-field>
            </div>

            <!-- Cellulare -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="phone" class="w-1/4 sheet-label pt-2"
                >Cellulare</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="phone"
                  type="tel"
                  formControlName="phone"
                  placeholder="Telefono"
                />
                <hlm-error>Inserire un numero di telefono valido</hlm-error>
              </hlm-form-field>
            </div>

            <!-- SDI -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="sdi" class="w-1/4 sheet-label pt-2"
                >SDI</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="sdi"
                  type="text"
                  formControlName="sdi"
                  placeholder="Codice SDI"
                />
              </hlm-form-field>
            </div>

            <!-- P.IVA -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="vatNumber" class="w-1/4 sheet-label pt-2"
                >P.IVA</label
              >
              <hlm-form-field class="w-3/4">
                <input
                  hlmInput
                  id="vatNumber"
                  type="text"
                  formControlName="vatNumber"
                  placeholder="Partita IVA"
                />
              </hlm-form-field>
            </div>

            <!-- Compagnia Assicurativa -->
            <div class="flex items-start gap-4">
              <label
                hlmLabel
                for="insuranceCompany"
                class="w-1/4 sheet-label pt-2"
                >Compagnia assicurativa</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <input
                    hlmInput
                    id="insuranceCompany"
                    type="text"
                    formControlName="insuranceCompany"
                    placeholder="Es. Allianz S.p.A."
                  />
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="insuranceCompanyTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #insuranceCompanyTooltip>
                  <div class="max-w-xs">
                    La compagnia assicurativa viene utilizzata per
                    l'esportazione dei contratti (Art. 8).
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Numero Polizza -->
            <div class="flex items-start gap-4">
              <label hlmLabel for="policyNumber" class="w-1/4 sheet-label pt-2"
                >Numero polizza</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <input
                    hlmInput
                    id="policyNumber"
                    type="text"
                    formControlName="policyNumber"
                    placeholder="Es. POL-2024-001234"
                  />
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="policyNumberTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #policyNumberTooltip>
                  <div class="max-w-xs">
                    Il numero di polizza viene utilizzato per l'esportazione dei
                    contratti (Art. 8).
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Error Message -->
            @if (hasError()) {
              <div class="flex items-start gap-4">
                <div class="w-1/4"></div>
                <div class="w-3/4">
                  <p class="text-sm text-destructive">
                    {{ errorMessage() }}
                  </p>
                </div>
              </div>
            }
          </form>
        </div>
      </o2-accordion-item>

      <!-- Configurazione Accordion -->
      <o2-accordion-item label="Configurazione">
        <div class="p-5 pt-2">
          <form [formGroup]="tenantForm" class="flex flex-col gap-3.5">
            <!-- Costi Indiretti -->
            <div class="flex items-center gap-4">
              <label hlmLabel for="indirectCosts" class="w-1/4 sheet-label"
                >Costi indiretti</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <div hlmInputGroup>
                    <input
                      hlmInputGroupInput
                      id="indirectCosts"
                      type="number"
                      formControlName="indirectCosts"
                      placeholder="0"
                      step="0.1"
                    />
                    <span hlmInputGroupAddon align="inline-end">€/h</span>
                  </div>
                  <hlm-error
                    >Inserire un valore maggiore o uguale a 0</hlm-error
                  >
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="indirectCostsTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #indirectCostsTooltip>
                  <div class="max-w-xs">
                    Costi fissi aziendali (affitto, software, admin) divisi per
                    ore lavorate. Vengono aggiunti al costo orario di ogni
                    risorsa.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Margine -->
            <div class="flex items-center gap-4">
              <label hlmLabel for="margin" class="w-1/4 sheet-label"
                >Indice di margine</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <input
                    hlmInput
                    id="margin"
                    type="number"
                    formControlName="margin"
                    placeholder="Es. 1.3"
                    step="0.1"
                  />
                  <hlm-error
                    >Inserire un valore maggiore o uguale a 0</hlm-error
                  >
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="marginTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #marginTooltip>
                  <div class="max-w-xs">
                    Indice applicato al costo totale (costo orario sommato ai
                    costi indiretti) per ottenere la tariffa di vendita. Un
                    valore di 1,5 corrisponde a un margine del 50%.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Tariffa oraria fatturabile -->
            <div class="flex items-center gap-4">
              <label hlmLabel for="billableHourlyRate" class="w-1/4 sheet-label"
                >Tariffa oraria fatturabile</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <div hlmInputGroup>
                    <input
                      hlmInputGroupInput
                      id="billableHourlyRate"
                      type="number"
                      formControlName="billableHourlyRate"
                      placeholder="0"
                      step="0.1"
                    />
                    <span hlmInputGroupAddon align="inline-end">€/h</span>
                  </div>
                  <hlm-error
                    >Inserire un valore maggiore o uguale a 0</hlm-error
                  >
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="billableHourlyRateTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #billableHourlyRateTooltip>
                  <div class="max-w-xs">
                    Tariffa oraria di default per la fatturazione ai clienti.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Contributo Inarcassa -->
            <div class="flex items-center gap-4">
              <label
                hlmLabel
                for="inarcassaContribution"
                class="w-1/4 sheet-label"
                >Contributo Inarcassa</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <o2-button-group
                  class="flex-1"
                  [options]="inarcassaOptions"
                  formControlName="inarcassaContribution"
                />
                <button
                  type="button"
                  [hlmTooltipTrigger]="inarcassaTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #inarcassaTooltip>
                  <div class="max-w-xs">
                    Abilita il calcolo del contributo integrativo Inarcassa (4%)
                    per professionisti iscritti all'albo.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Durata Sprint -->
            <div class="flex items-center gap-4">
              <label hlmLabel for="sprint" class="w-1/4 sheet-label"
                >Durata sprint</label
              >
              <div class="flex items-center gap-2 w-3/4">
                <hlm-form-field class="flex-1">
                  <brn-select
                    class="w-full"
                    placeholder="Seleziona durata"
                    formControlName="sprint"
                  >
                    <hlm-select-trigger class="w-full">
                      <hlm-select-value />
                    </hlm-select-trigger>
                    <hlm-select-content>
                      @for (
                        option of sprintDurationOptions;
                        track option.value
                      ) {
                        <hlm-option [value]="option.value">
                          {{ option.label }}
                        </hlm-option>
                      }
                    </hlm-select-content>
                  </brn-select>
                </hlm-form-field>
                <button
                  type="button"
                  [hlmTooltipTrigger]="sprintTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #sprintTooltip>
                  <div class="max-w-xs">
                    Durata degli sprint per la pianificazione delle attività.
                    Determina la suddivisione del carico di lavoro nel
                    calendario.
                  </div>
                </ng-template>
              </div>
            </div>

            <!-- Soglie di avviso budget -->
            <div class="flex items-start gap-4">
              <span class="w-1/4 sheet-label">Soglie avviso budget</span>
              <div class="flex items-start gap-2 w-3/4">
                <div class="flex-1 grid grid-cols-2 gap-2">
                  @for (field of budgetThresholdFields; track field.control) {
                    <hlm-form-field>
                      <div hlmInputGroup>
                        <input
                          hlmInputGroupInput
                          [id]="field.control"
                          type="number"
                          [formControlName]="field.control"
                          [attr.aria-label]="field.label"
                          placeholder="—"
                          [attr.min]="budgetThresholdMin"
                          [attr.max]="budgetThresholdMax"
                          step="1"
                        />
                        <span hlmInputGroupAddon align="inline-end">%</span>
                      </div>
                      <hlm-error
                        >Inserire un intero tra {{ budgetThresholdMin }} e
                        {{ budgetThresholdMax }}</hlm-error
                      >
                    </hlm-form-field>
                  }
                </div>
                <button
                  type="button"
                  [hlmTooltipTrigger]="budgetThresholdsTooltip"
                  class="cursor-help"
                >
                  <ng-icon hlm size="sm" name="lucideInfo" />
                </button>
                <ng-template #budgetThresholdsTooltip>
                  <div class="max-w-xs">
                    Percentuali di consumo del budget di progetto (1–100). Al
                    raggiungimento di una soglia, gli admin e il project manager
                    ricevono un'email. Ogni soglia vale sia per il budget
                    economico che per le ore. Lascia vuoto per disattivarla.
                  </div>
                </ng-template>
              </div>
            </div>
          </form>
        </div>
      </o2-accordion-item>

      <!-- Modelli documenti Accordion -->
      <o2-accordion-item label="Modelli documenti">
        <div class="p-5 pt-2">
          <!-- Info box: come funziona -->
          <div
            class="rounded-md border border-blue-200 bg-blue-50 dark:border-blue-900 dark:bg-blue-950/30 p-4 mb-5"
          >
            <div class="flex items-start gap-3">
              <ng-icon
                hlm
                name="lucideInfo"
                size="sm"
                class="text-blue-600 dark:text-blue-400 shrink-0 mt-0.5"
              />
              <div class="flex flex-col gap-2 text-sm">
                <p class="font-semibold text-foreground">Come funziona</p>
                <p class="text-muted-foreground">
                  Personalizza preventivi e contratti caricando un tuo modello
                  Word. Il processo è semplice:
                </p>
                <ol
                  class="list-decimal list-inside text-muted-foreground space-y-0.5"
                >
                  <li>Scarica il modello esempio</li>
                  <li>
                    Aprilo in Word e modifica liberamente layout, colori, testi,
                    intestazioni
                  </li>
                  <li>Ricaricalo qui</li>
                </ol>
              </div>
            </div>
          </div>

          <div
            hlmAlert
            class="mb-5 border-amber-400 bg-amber-50 text-foreground dark:border-amber-600 dark:bg-amber-950/30"
          >
            <ng-icon
              hlmAlertIcon
              name="lucideTriangleAlert"
              class="text-amber-500"
            />
            <h4 hlmAlertTitle class="text-xs font-semibold">Importante</h4>
            <p hlmAlertDescription class="block! text-xs">
              I testi tra parentesi graffe come
              <code class="font-mono bg-muted px-1 rounded">{{
                "{nome_cliente}"
              }}</code>
              o
              <code class="font-mono bg-muted px-1 rounded">{{
                "{totale}"
              }}</code>
              sono segnaposto che verranno sostituiti con i dati reali al
              momento dell'esportazione. Puoi spostarli dove vuoi, ma
              <strong>non cancellarli</strong> — altrimenti quel dato non
              apparirà nel documento finale.
            </p>
          </div>

          <div class="space-y-6">
            <!-- Preventivo -->
            <div>
              <h4 hlmLabel class="mb-3">Preventivo</h4>

              @if (tenant()?.quoteTemplateS3Key) {
                <div
                  class="flex items-center justify-between rounded-md border border-border bg-muted/30 px-3 py-2.5 mb-3"
                >
                  <div class="flex items-center gap-2 min-w-0">
                    <span class="text-green-600">
                      <ng-icon hlm name="lucideCircleCheck" size="xs" />
                    </span>
                    <span
                      class="text-xs text-muted-foreground truncate"
                      [title]="tenant()?.quoteTemplateS3Key ?? ''"
                    >
                      {{ tenant()?.quoteTemplateS3Key?.split("/")?.pop() }}
                    </span>
                  </div>
                  <button
                    type="button"
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    class="h-7 w-7 text-destructive hover:text-destructive shrink-0"
                    (click)="confirmRemoveQuoteTemplate()"
                  >
                    <ng-icon hlm name="lucideTrash2" size="xs" />
                  </button>
                </div>
              }

              <div class="flex gap-2">
                <button
                  type="button"
                  hlmBtn
                  variant="outline"
                  size="sm"
                  (click)="downloadQuoteTemplateExample()"
                >
                  <ng-icon hlm name="lucideFileText" size="sm" class="mr-1" />
                  Scarica esempio
                </button>
                <button
                  type="button"
                  hlmBtn
                  variant="outline"
                  size="sm"
                  (click)="triggerQuoteTemplateUpload()"
                >
                  <ng-icon hlm name="lucideUpload" size="sm" class="mr-1" />
                  Carica
                </button>
              </div>
            </div>

            <!-- Contratto -->
            <div>
              <h4 hlmLabel class="mb-3">Contratto</h4>

              @if (tenant()?.contractTemplateS3Key) {
                <div
                  class="flex items-center justify-between rounded-md border border-border bg-muted/30 px-3 py-2.5 mb-3"
                >
                  <div class="flex items-center gap-2 min-w-0">
                    <span class="text-green-600">
                      <ng-icon hlm name="lucideCircleCheck" size="xs" />
                    </span>
                    <span
                      class="text-xs text-muted-foreground truncate"
                      [title]="tenant()?.contractTemplateS3Key ?? ''"
                    >
                      {{ tenant()?.contractTemplateS3Key?.split("/")?.pop() }}
                    </span>
                  </div>
                  <button
                    type="button"
                    hlmBtn
                    variant="ghost"
                    size="icon"
                    class="h-7 w-7 text-destructive hover:text-destructive shrink-0"
                    (click)="confirmRemoveContractTemplate()"
                  >
                    <ng-icon hlm name="lucideTrash2" size="xs" />
                  </button>
                </div>
              }

              <div class="flex gap-2">
                <button
                  type="button"
                  hlmBtn
                  variant="outline"
                  size="sm"
                  (click)="downloadContractTemplateExample()"
                >
                  <ng-icon hlm name="lucideFileText" size="sm" class="mr-1" />
                  Scarica esempio
                </button>
                <button
                  type="button"
                  hlmBtn
                  variant="outline"
                  size="sm"
                  (click)="triggerContractTemplateUpload()"
                >
                  <ng-icon hlm name="lucideUpload" size="sm" class="mr-1" />
                  Carica
                </button>
              </div>
            </div>
          </div>
        </div>
      </o2-accordion-item>
    </o2-accordion-group>
  </div>

  <!-- Template validation errors dialog (syntax errors) -->
  <app-template-validation-errors-dialog
    (downloadExampleRequested)="downloadTemplateExample($event)"
  />

  <!-- Template validation warnings dialog (missing canonical placeholders) -->
  <app-template-validation-warnings-dialog
    (confirmed)="onWarningConfirmed()"
    (cancelled)="onWarningCancelled()"
  />

  <!-- Remove template confirmation dialog -->
  <app-template-remove-confirm-dialog (confirmed)="onRemoveConfirmed()" />

  <div o2SheetFooter>
    <button type="button" hlmBtn variant="outline" (click)="close()">
      Annulla
    </button>
    <button
      type="button"
      hlmBtn
      variant="default"
      (click)="save()"
      [disabled]="isSaveDisabled()"
    >
      Salva
    </button>
  </div>
</o2-sheet>
